import { APIClient } from '@/services'
import { PersonaCTAModal } from '../modals'
import { navigation } from '@/app'

export const requiredAnswers: Array<keyof APIClient.Session.Profile> = [
  'confidence_at_work',
  'satisfaction_at_work',
  'seniority',
  'department',
  'learning_motivations',
]

export function getMissingAnswers() {
  const profile = APIClient.Session.QueryKeys.me.getData()

  return requiredAnswers.filter(key => {
    const answer = profile?.[key]

    if (Array.isArray(answer)) return !answer.length
    return !answer
  })
}

export function hasMissingAnswers() {
  const profile = APIClient.Session.QueryKeys.me.getData()

  return requiredAnswers.some(key => {
    const answer = profile?.[key]

    if (Array.isArray(answer)) return !answer.length
    return !answer
  })
}

export function onPressLearn() {
  const canProceed = APIClient.UnknownProfile.maybeOpenRegistrationWall()
  if (!canProceed) {
    return
  }

  const missingAnswers = hasMissingAnswers()
  if (missingAnswers) {
    PersonaCTAModal.open()
  }

  navigation.navigate('Learn.Learn')
}
